export default "__VITE_ASSET__Ds4fc8ZT__"